export class NotificationSettingInfoComponentController {
  private models: {
    email: string;
    phoneNumber: string;
  };
  private flags: {
    hasEmail: boolean;
    hasNumber: boolean;
    isValidNumber: boolean;
    isEditable: boolean;
    verifyingNumber: boolean;
  };
  private isEditable: boolean;
  constructor(
    private contactInformationModel: any,
    private TypeUtility: any,
    private phoneNumberService: any
  ) {
    this.models = {
      email: ``,
      phoneNumber: ``
    };
    this.flags = {
      hasEmail: true,
      hasNumber: true,
      isValidNumber: true,
      isEditable: true,
      verifyingNumber: false
    };
  }
  $onInit() {
    this.models = {
      email: this.contactInformationModel.updateWithAccountModelEmail(),
      phoneNumber: this.contactInformationModel.getPhoneNumber()
    };

    this.flags = {
      hasEmail: !_.isEmpty(this.models.email),
      hasNumber: !_.isEmpty(this.models.phoneNumber),
      isValidNumber: this.contactInformationModel.isVerifiedPhoneNumber(),
      isEditable: this.isEditable,
      verifyingNumber: false
    };
  }
  $onChanges(changeObj: { isEditable: { currentValue: boolean } }) {
    this.models.phoneNumber = this.contactInformationModel.getPhoneNumber();
    this.updateFlags(changeObj.isEditable.currentValue);
  }
  getPhoneNumberDisplay(number: number) {
    return !_.isEmpty(number) ? this.phoneNumberService.getDisplayNumber(number) : `No cell number`;
  }

  updateFlags(isEditableValue: boolean) {
    if (!isEditableValue) {
      this.resetVerifyingFlag();
    }
    _.merge(this.flags, {
      hasEmail: !_.isEmpty(this.models.email),
      hasNumber: !_.isEmpty(this.models.phoneNumber),
      isValidNumber: this.contactInformationModel.isVerifiedPhoneNumber(),
      isEditable: isEditableValue
    });
  }

  isVerifying() {
    this.flags.verifyingNumber = true;
  }

  resetVerifyingFlag() {
    this.flags.verifyingNumber = false;
  }

  truncatedEmail() {
    return this.TypeUtility.StringUtility.truncateString(28, this.models.email);
  }
}

export class NotificationSettingInfoComponent implements ng.IComponentOptions {
  public templateUrl: string = 'lib/my_settings/components/notification_settings_info/notification_settings_info.html';
  public controller: any = NotificationSettingInfoComponentController;
  public bindings: any = {
    isEditable: '<'
  };
}



// WEBPACK FOOTER //
// ./app/lib/my_settings/components/notification_settings_info/notification_settings_info.ts